import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EnhancedTable, Subtitulo } from "@monorepo-web/components-library";
export default function BaseTabela({ rows, titulo, height = 500, layout = 'default', layouts, enhancedTableProps = {}, }) {
    const columns = layouts[layout];
    return (_jsxs(_Fragment, { children: [titulo ? _jsx(Subtitulo, Object.assign({ mb: "8px" }, { children: titulo })) : null, _jsx(EnhancedTable, Object.assign({ rows: rows, columns: columns, height: height }, enhancedTableProps))] }));
}
